import React from 'react';
import cn from 'classnames';
import _isArray from 'lodash/isArray';
import _toNumber from 'lodash/toNumber';
import styles from './index.module.scss';

/**
 * @param {object} props
 * @param {string | import('utils/types').Space} props.gap - The gap between grid items, can be a number (in pixels) or a valid CSS gap value.
 * @param {string} props.templateColumns - The CSS grid-template-columns value.
 * @param {string} props.templateRows - The CSS grid-template-rows value.
 * @param {string} props.className - Additional class names for the grid container.
 * @param {React.ReactNode} props.children - Child elements to render inside the grid.
 */
export default function Grid({
  gap = 0,
  templateColumns = '',
  templateRows = 'auto',
  className = '',
  children = null,
  style = {},
  ...divElementProps
}) {
  const count = _isArray(children) ? children.filter(Boolean).length : 1;

  const gridColumns = templateColumns
    ? templateColumns
    : Array.from({ length: count }, () => '1fr').join(' ');

  return (
    <div
      {...divElementProps}
      className={cn(styles.container, className)}
      style={{
        gridTemplateRows: templateRows,
        gridTemplateColumns: gridColumns,
        gap: _toNumber(gap) ? `${gap}px` : gap,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
